import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { INSERT_LIQUID, LIQUID_ENABLED_FIELD_FOCUS_IN, LIQUID_ENABLED_FIELD_FOCUS_OUT } from 'cio/services/event-bus';

export default class Editor extends Component {
  @service auth;
  @service eventBus;

  didInsertElement() {
    let eventBus = this.get('eventBus');

    eventBus.subscribe(INSERT_LIQUID, this, this.insertLiquid);
  }

  willDestroyElement() {
    let eventBus = this.get('eventBus');

    eventBus.unsubscribe(INSERT_LIQUID, this, this.insertLiquid);
  }

  /**
    Runs when the INSERT_LIQUID event is published through the event bus.
    @method insertLiquid
    @param {Array} field - [fieldName, index], an array containing the field
      name, and an index, for when there are multiple fields of the same name.
    @param {string} liquid - The liquid to be inserted.
    @param {string} fallback - An optional fallback for liquid.
    @public
  */
  insertLiquid() {}

  @action
  liquidFieldFocusIn(fieldName, index = 0) {
    this.get('eventBus').publish(LIQUID_ENABLED_FIELD_FOCUS_IN, [fieldName, index]);
  }

  @action
  liquidFieldFocusOut() {
    this.get('eventBus').publish(LIQUID_ENABLED_FIELD_FOCUS_OUT);
  }
}
